import { render, staticRenderFns } from "./Minimum.vue?vue&type=template&id=6ed5ecd8&scoped=true"
import script from "./Minimum.vue?vue&type=script&lang=ts"
export * from "./Minimum.vue?vue&type=script&lang=ts"
import style0 from "./Minimum.vue?vue&type=style&index=0&id=6ed5ecd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5ecd8",
  null
  
)

export default component.exports